import { useCallback, useEffect, useState } from "react";
import { apiRequest } from "../../../shared/api/client";
import type { Check } from "./preparation-types";
import type { SessionUser } from "../../../shared/auth/access";
import { materialPreparationEmptyState } from "../material-preparation-view";
import type { PreparationCheckSummary } from "../material-preparation-view";
export function useMaterialPreparationWorkspace({ refreshVersion, }: {
    notify: (message: string) => void;
    refreshVersion: number;
    user: SessionUser;
}) {
    const [checks, setChecks] = useState<Check[]>([]);
    const [summary, setSummary] = useState<PreparationCheckSummary | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await apiRequest<{
                items: Check[];
                summary?: PreparationCheckSummary;
            }>("/api/material-preparation/checks?latest=true&exceptions=true", {
                cache: "no-store",
            });
            setChecks(result.items);
            setSummary(result.summary ?? null);
        }
        catch (cause) {
            const message = cause instanceof Error
                ? cause.message
                : "Malzeme hazırlık kontrolleri yüklenemedi.";
            setError(message);
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        void load();
    }, [load, refreshVersion]);
    const emptyState = materialPreparationEmptyState(summary);
    return { checks, setChecks, loading, error, load, emptyState };
}
